import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { PageRoutes } from "../../../constants/routes";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { useNavigation } from "../../../hooks/useNavigation";

export const useCustomerInfoConfirmation = () => {
  const dispatch = useDispatch();
  const { navigateToPage } = useNavigation();
  const { state } = useLocation();

  const {
    key,
    type,
    value,
    name,
    phoneNumber,
    email,
    password,
    passwordConfirmation,
  } = state ?? {};

  const handleRegisterUser = useCallback(() => {
    dispatch(appActions.showLoading());
    dispatch(
      authActions.register.started({
        key,
        name,
        tel: phoneNumber,
        email,
        password,
        password_confirmation: passwordConfirmation,
        // TODO: change to selected language
        lang: "ja",
        onComplete: () => dispatch(appActions.hideLoading()),
        onSuccess: () => navigateToPage(PageRoutes.MEMBERSHIP_INFO_SENT),
      }),
    );
  }, []);

  const handleRegisterUserMail = useCallback(() => {
    dispatch(appActions.showLoading());
    dispatch(
      authActions.registerMail.started({
        key,
        name,
        tel: phoneNumber,
        password,
        password_confirmation: passwordConfirmation,
        // TODO: change to selected language
        lang: "ja",
        onComplete: () => dispatch(appActions.hideLoading()),
        onSuccess: () => navigateToPage(PageRoutes.MEMBERSHIP_INFO_SENT),
      }),
    );
  }, []);

  const handleGoBack = useCallback(() => {
    navigateToPage(PageRoutes.REGISTRATION.replace(":key", key), false, {
      type,
      value,
      name,
      email,
      phoneNumber,
      password,
    });
  }, []);

  return {
    name,
    phoneNumber,
    email,
    password,
    handleRegisterUser,
    handleRegisterUserMail,
    handleGoBack,
  };
};
